<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg"
                   :visible="modal.show"
                   :data="model"
                   :title="$t('Assign Clerks')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Save')"
                   :is-loading="loading"
                   scrollable>

      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between">
            <input-widget :model="model" type="number" :label="false" attribute="telephone_bids_lot_spacing"
                          placeholder="Lot Spacing"/>
            <b-button style="height: fit-content" variant="primary" @click="onGenerateClick()">
              {{ $t('Generate') }}
            </b-button>
          </div>
          <div class="row mt-3">
            <div class="artisio-table assign-clerks-table col-md-12">
              <spinner :show="modalLoading" :withText="true"/>
              <table class="table table-lg" v-if="!modalLoading">
                <thead>
                <tr>
                  <th>{{ $t('Lot') }}</th>
                  <th>{{ $t('Bidder') }}</th>
                  <th>{{ $t('Preferred Clerk') }}</th>
                  <th>{{ $t('Preferred Language') }}</th>
                  <th>{{ $t('Cover Amount') }}</th>
                  <th>{{ $t('Assigned Clerk') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(bid,index) in bids" :key="`lot_${index}`">
                  <td>
                    <router-link v-if="$hasPermission('view_inventoryitem')"
                                 :to="{ name: 'inventory.view', params: { id: bid.lot.inventory_uuid }}">
                      {{ bid.lot.lot_no }}
                    </router-link>
                  </td>
                  <td>
                    <router-link v-if="$hasPermission('view_customer')"
                                 :to="{ name: 'customers.dashboard', params: { id: bid.bidder.customer ? bid.bidder.customer.uuid :
                      ''}}">
                      {{ bid.bidder.customer ? bid.bidder.customer.display_name : '' }}
                    </router-link>
                    <p v-else> {{ bid.bidder.customer ? bid.bidder.customer.display_name : '' }} </p>
                  </td>
                  <td>
                    {{ bid.bidder.preferred_clerk ? bid.bidder.preferred_clerk.name : '' }}
                  </td>
                  <td>
                    {{ bid.bidder.language ? bid.bidder.language.name : '' }}
                  </td>
                  <td v-if="modal.object.currency">
                    {{ bid.cover_amount | asCurrency(modal.object.currency.symbol)}}
                  </td>
                  <td v-else>
                    {{ modal.object}}
                  </td>
                  <td>
                    <clerk-select-input-widget :label="false" :model="bid" attribute="clerk_uuid" type="text"
                                               :items="clerks"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </artisio-modal>
    <clerks-modal/>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../core/components/input-widget/InputWidget.vue";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal.vue";
  import {createNamespacedHelpers} from "vuex";
  import AuctionClerk from "@/modules/telephone-bids/models/AuctionClerk.model";
  import {SOURCE_TELEPHONE_BIDS_TABLE} from "@/modules/constants";
  import ClerksModal from "@/modules/setup/branch/tabs/clerks/ClerksModal.vue";
  import i18n from "@/shared/i18n";
  import ClerkSelectInputWidget from "@/core/widgets/ClerkSelectInputWidget.vue";
  import AssignClerks from "@/modules/telephone-bids/models/AssignClerks.model";
  import TelephoneBidModal from "@/modules/telephone-bids/models/TelephoneBidModal.model";
  import SalesService from "@/modules/sales/SalesService";
  import Spinner from "@/core/components/common/Spinner.vue";
  import TelephoneBidsService from "@/modules/telephone-bids/TelephoneBidsService";

  const {mapState, mapActions} = createNamespacedHelpers('telephoneBids');
  const {mapActions: clerksMapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "AssignClerksModal",
    components: {
      Spinner,
      ClerkSelectInputWidget,
      ClerksModal,
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        SOURCE_TELEPHONE_BIDS_TABLE: SOURCE_TELEPHONE_BIDS_TABLE,
        loading: false,
        showConfirmation: true,
        model: new AssignClerks(),
        clerks: [],
        bids: [],
      }
    },
    computed: {
      ...mapState({
        modal: state => state.assignClerksModal,
        telephoneBids: state => state.assignClerksModal.telephoneBids,
        modalLoading: state => state.assignClerksModal.loading,
      }),
    },
    watch: {
      telephoneBids() {
        if (this.telephoneBids) {
          this.bids = this.telephoneBids.map(bid => new TelephoneBidModal(bid))
        }
      }
    },
    methods: {
      ...mapActions(['hideAssignClerksModal', 'saveAssignedClerks', 'updateAssignClerksModalLoading']),
      ...clerksMapActions({
        showClerksModal: 'showClerksModal'
      }),
      onShow() {
        this.showConfirmation = true;
        this.selectedClerks = this.modal.object.clerks;
        this.clerks = this.modal.object.clerks;
        this.model.telephone_bids_lot_spacing = this.modal.object.telephone_bids_lot_spacing;
      },
      onHidden() {
        this.model = new AuctionClerk();
        this.bids = []
        this.selectedClerks = [];
        this.hideAssignClerksModal();
      },
      async onSubmit() {
        let requestData = [];

        this.bids.forEach((bid) => {
          requestData.push({
            uuid: bid.uuid,
            clerk_uuid: bid.clerk_uuid,
          })
        });

        let saveResponse = await this.saveAssignedClerks({
          sale_uuid: this.modal.object.uuid,
          telephone_bids_lot_spacing: this.model.telephone_bids_lot_spacing,
          requestData
        });

        if (saveResponse.success) {
          this.showConfirmation = false;
          this.hideAssignClerksModal();
          this.$toast('success', this.$t('Clerks successfully assigned'));
        } else {
          if (saveResponse.toastError) {
            this.$errorDialog(saveResponse.toastError);
          } else {
            if (saveResponse.body.non_field_errors) {
              this.$errorDialog(saveResponse.body.non_field_errors[0]);
            } else {
              // todo double check if this logic works
              for (let index in saveResponse.body) {
                this.bids[index].setMultipleErrors(saveResponse.body[index]);
              }
            }
          }
        }

      },
      async onGenerateClick() {
        this.model.resetErrors();
        await this.updateAssignClerksModalLoading(true)
        let response = await TelephoneBidsService.generateAssignClerks({
          sale_no: this.modal.object.sale_no,
          telephone_bids_lot_spacing: this.model.telephone_bids_lot_spacing
        });
        if (response.success) {
          this.bids = response.body.map(bid => new TelephoneBidModal(bid))
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
        await this.updateAssignClerksModalLoading(false)
      },
    }
  }
</script>

<style scoped>
  /deep/ .form-group {
    margin-bottom: 0rem;
  }

  .assign-clerks-table .table th, .table td {
    padding: 0.25rem
  }
</style>
